import styled from "styled-components";
import { FixedSpan } from "./FixedSpan";
import { PreviewLink as Link } from "./PreviewLink";

const darkRed = "#bd0000";

export const DropZoneStyle = styled.div<{
  isError: boolean;
  isDisabled: boolean;
}>`
  flex: 1;
  display: flex;
  gap: 15px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 5px;
  border-color: ${(props) =>
    props.isError ? "red" : props.isDisabled ? "#DFDFDF" : "#979797"};
  border-style: ${(props) => (props.isError ? `ridge` : `dashed`)};
  background-color: ${(props) => (props.isDisabled ? "#F8F8F8" : "#ffffff")};
  color: ${(props) => (props.isDisabled ? "#C7C7C7" : "#737373")};
  outline: none;
  min-height: 122px;
  transition: border 0.24s ease-in-out;
  box-shadow: ${(props) =>
    props.isDisabled ? "0 4px 2px -2px #DFDFDF" : "0 4px 2px -2px lightgray"};
`;

export const StyledSection = styled.section`
  margin-bottom: 2.17rem;
`;

export const StyledErrorMessage = styled.small<{ fontWeight: string }>`
  color: ${darkRed};
  font-weight: ${({ fontWeight }) => fontWeight};
`;

export const StyledWarningMessage = styled.div`
  font-size: 0.75em;
  color: #0d0d0d;
  margin-left: 16px;
`;

export const StyledSpan = styled(FixedSpan)`
  font-size: 0.75em;
`;

export const PreviewLink = styled(Link)`
  color: ${darkRed};
  font-size: 0.75em;
  text-decoration: underline;
  cursor: pointer;
`;

export const FadedImg = styled.img`
  opacity: 0.5;
`;
